import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GaGeographyModule } from 'gain-lib/geography';
import { GaCountrySelectDialogComponent } from './country-select/country-select-dialog/country-select-dialog.component';
import { GaCountrySelectComponent } from './country-select/country-select.component';

@NgModule({
  declarations: [GaCountrySelectComponent, GaCountrySelectDialogComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    MatDialogModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    GaGeographyModule,
    MatExpansionModule,
    MatTooltipModule,
  ],
  exports: [GaCountrySelectComponent],
})
export class GaCountrySelectModule {}
